/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React, { FunctionComponent } from 'react'
import { Route, Switch } from 'react-router-dom'

import Reviews from 'Containers/Reviews'
import Balance from 'Containers/Balance'
import PlayLists from 'Containers/Playlists'
import Rank from 'Containers/Rank'
import TracksFeed from 'Containers/TracksFeed'
import AdminProtected from './AdminProtected'
import SettingsComponents from './routes/artistRoutes/SettingsComponents'
import SettingsRoute from './routes/artistRoutes/SettingsRoute'

import {
  reviews,
  tracksFeed,
  settings,
  balance,
  playlists,
  rank,
  login,
  admin,
  analytics,
} from './routes'
import { UserComponentsProps } from './props'

const CuratorComponents: FunctionComponent<UserComponentsProps> = ({
  user,
}) => (
  <>
    <Switch>
      <Route
        path={[
          '/',
          reviews,
          tracksFeed,
          login,
          `${reviews}/:confirm`,
          balance,
          playlists,
          rank,
        ]}
        exact
      >
        <Switch>
          <Route component={Reviews} exact path="/" />
          <Route component={Reviews} exact path={reviews} />
          <Route component={Reviews} path={login} />
          {/* TODO check "confirm" */}
          <Route component={Reviews} exact path={`${reviews}/:confirm`} />
          <Route component={TracksFeed} exact path={tracksFeed} />
          <Route component={Balance} exact path={balance} />
          <Route component={PlayLists} exact path={playlists} />
          <Route component={Rank} exact path={rank} />
        </Switch>
      </Route>

      <Route path={[settings]}>
        <SettingsRoute component={SettingsComponents} />
      </Route>

      <Route path={[admin, analytics]}>
        <AdminProtected user={user} />
      </Route>

      <Route component={Reviews} path="*" />
    </Switch>
  </>
)

export default CuratorComponents
